<app-loader [isLoading]="isLoading"></app-loader>

<div class="header form-header">
    <div class="top">
        <a routerLink="/home/users/policies">
            <h3>Políticas /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? 'Editar política' : 'Añadir política' }}</h2>
            </div>
        </a>
    </div>
</div>

<div class="content form">
    <form [formGroup]="policyForm">
        <h4>Nombre de la política: </h4>
        <mat-form-field appearance="outline" style="width: 500px">
            <input type="text" matInput placeholder="Nombre de la política" formControlName="policyName">
            @if (policyForm.get('policyName')?.invalid && policyForm.get('policyName')?.touched) {
            <mat-error>
                El nombre de la política es requerido
            </mat-error>
            }
        </mat-form-field>
        <br><br>
        <h4>Descripción de la política: </h4>
        <quill-editor formControlName="policyDescription" matInput [modules]="modules"
            [styles]="{height: '300px'}"></quill-editor>
        @if (policyForm.get('policyDescription')?.invalid && policyForm.get('policyDescription')?.touched) {
        <mat-error>
            La descripción de la política es requerida
        </mat-error>
        }
    </form>

    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de Funcionalidad -->
        <ng-container matColumnDef="functionality">
            <th mat-header-cell *matHeaderCellDef>
                FUNCIONALIDAD
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
                <span style="font-size: 16px;" [style.font-weight]="element.type === 'functionality' ? '600' : '400'"
                    [style.color]="element.type === 'functionality' ? '#000' : '#666'"
                    [style.padding-left]="element.type === 'subsection' ? '24px' : '0'">
                    {{element.title}}
                </span>
            </td>
        </ng-container>

        <!-- Columna de Escribir -->
        <ng-container matColumnDef="write">
            <th mat-header-cell *matHeaderCellDef>
                ESCRIBIR
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
                <mat-checkbox [(ngModel)]="element.permissions.write"></mat-checkbox>
            </td>
        </ng-container>

        <!-- Columna de Eliminar -->
        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>
                ELIMINAR
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
                <mat-checkbox [(ngModel)]="element.permissions.delete"></mat-checkbox>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveChanges()">
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
        </button>
        <button mat-flat-button id="cancel" routerLink="/home/users/policies">Cancelar</button>
    </div>
</div>